import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { buildUrlAndOpenSameWindow, navigateTo } from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';

//--------------- Swiper ---------------
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core';
import 'swiper/swiper.scss';
SwiperCore.use([Autoplay, Pagination, Navigation]);
//--------------- Swiper ---------------

const MobileNavigationMenu = (props) => {
    const navigationMenuItems = props.iContent.navigationMenuItems?.expandedValue || [];
    if (!navigationMenuItems) { return null; }

    useEffect(() => {
        document.body.style.paddingBottom = "90px";
    }, []);

    const isCentered = navigationMenuItems.length <= 5;

    return (
        <div className={`mobile-navigation-menu ${isCentered ? 'centered-mode' : ''}`} style={{backgroundColor: props.iContent.blockBackgroundColor?.value}}>
            <Swiper centeredSlidesBounds={false} centeredSlides={false} spaceBetween={0} slidesPerView={'auto'} speed={700} setWrapperSize={false} loop={false} slidesOffsetBefore={isCentered ? 0 : 16} slidesOffsetAfter={isCentered ? 0 : 16} >
                {
                    navigationMenuItems.map((item, index) => (
                        <SwiperSlide key={index} className='fixed-slide'>
                            <div key={index} className={`navigation-item ${isSelected(item.link?.value) ? 'active' : ''}`} onClick={() => handleOnItemClick(item.link?.value)}>
                                <div className='top-line' style={{backgroundColor: props.iContent.highlightColor?.value}}></div>
                                <div className='item-icon'>
                                    <Image className='icon-main' src={Config.epiBaseUrl + item.linkIcon?.value?.url} alt={item.linkText.value} />
                                    <Image className='icon-selected' src={Config.epiBaseUrl + item.linkIconSelected?.value?.url} alt={item.linkText.value} />
                                </div>
                                <div className='item-title' style={{color: isSelected(item.link?.value) ? props.iContent.selectedLinkTextColor?.value : props.iContent.linkTextColor?.value}}> { item.linkText.value } </div>
                            </div>
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    );

    function isSelected(link) {
        //console.info('document.location.pathname', document.location.pathname, '|', 'link', link);
        return (document.location.pathname == link);
    }

    function handleOnItemClick(link) {
        //navigateTo(link);
        buildUrlAndOpenSameWindow(link);
    }

};

export default MobileNavigationMenu;
